/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerOnlinePaymentTypesResponse as ModelsCustomerCustomerOnlinePaymentTypesResponse } from '../../models/Models/Customer/customer-online-payment-types-response';

export interface V4CustomersMeOnlinePaymentTypesGet$Json$Params {
}

export function v4CustomersMeOnlinePaymentTypesGet$Json(http: HttpClient, rootUrl: string, params?: V4CustomersMeOnlinePaymentTypesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeOnlinePaymentTypesGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerOnlinePaymentTypesResponse>;
    })
  );
}

v4CustomersMeOnlinePaymentTypesGet$Json.PATH = '/v4/customers/me/online-payment-types';
